import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { LocationIcon, CalendarIcon } from '../../icons'
import { formatDateToLongFormat } from '#app/utils/timeUtils'

type ExhibitionProps = {
  metadata: {
    properties: {
      name?: string;
      description?: string;
      location?: string;
      startDate?: string;
      endDate?: string;
    };
  };
}

export default function Exhibition({ metadata }: ExhibitionProps) {
  const { properties } = metadata;

  return (
    <div className="flex flex-col space-y-2">
      {/* Exhibition Title */}
      <TypographyHeader size="small" additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark">
        {properties.name || 'Untitled Exhibition'}
      </TypographyHeader>

      {/* Exhibition Info */}
			{(properties.startDate || properties.endDate) && (
				<div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
					<CalendarIcon size="small" />
					<TypographyLabel size="small">
						{properties.startDate && formatDateToLongFormat(properties.startDate)}
						{properties.startDate && properties.endDate && ' - '}
						{properties.endDate && formatDateToLongFormat(properties.endDate)}
					</TypographyLabel>
				</div>
			)}

			{properties.location && (
				<div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
					<LocationIcon size="small" />
					<TypographyLabel size="small">
						{properties.location}
					</TypographyLabel>
				</div>
			)}

      {/* Exhibition Description */}
      <TypographyParagraph size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">
        {properties.description ? `${properties.description.slice(0, 116)}${properties.description.length > 116 ? '...' : ''}` : 'No description available'}
      </TypographyParagraph>

    </div>
  );
} 